import { Subject } from 'rxjs';

const subject = new Subject();
export default subject